// extracted by mini-css-extract-plugin
export default {"bonusTab":"styles_bonusTab__ZKbf9","bonusTabActive":"styles_bonusTabActive__FxaYK"};